<template>
    <v-carousel
        height="100%"
        hide-controls
        hide-delimiters
        class="full-page-carousel"
    >
        <v-carousel-item
            v-for="(img, i) in validImages"
            :key="i"
        >
            <img :src="img">
        </v-carousel-item>
        <slot />
    </v-carousel>
</template>

<script>
export default {
    name: 'full-page-carousel',
    props: {
        images: {
            type: Array,
            required: true,
        },
        mobileImages: {
            type: Array,
            required: true,
        },
    },
    computed: {
        validImages() {
            return this.mobile
                ? this.mobileImages
                : this.images
        }
    }
}
</script>

<style lang="scss" scoped>
 @import '../../assets/scss/breakpoint';

    .full-page-carousel {
        height: 100% !important;
        width: 100%;
        box-shadow: none;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .v-window__container{
          height: 100% !important;
        }

        .v-window-item {
          position: absolute;
          height: 100% !important;
        }
    }

</style>



// WEBPACK FOOTER //
// ./src/components/auth/FullPageCarousel.vue